import { render, staticRenderFns } from "./BaseAttrsItem.vue?vue&type=template&id=5d0a2582&"
import script from "./BaseAttrsItem.vue?vue&type=script&lang=js&"
export * from "./BaseAttrsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d0a2582')) {
      api.createRecord('5d0a2582', component.options)
    } else {
      api.reload('5d0a2582', component.options)
    }
    module.hot.accept("./BaseAttrsItem.vue?vue&type=template&id=5d0a2582&", function () {
      api.rerender('5d0a2582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/attr/items/BaseAttrsItem.vue"
export default component.exports